

export function parseStringifiedNumbersFromSheetData(sheetData){
    return sheetData.map(item => ({
        ...item,
        quantity: parseStringifiedNumbers(item.quantity),
        total_price: parseStringifiedNumbers(item.total_price),
    }))
}

function parseStringifiedNumbers(number){
    if(typeof number !== 'string'){
        return number
    }
    
    number = number.split(',').join('.')
    
    if(number.split('.').length > 2){
        throw new Error('Invalid number found: '+ number +' - Multiple commas detected')
    }

    return parseFloat(number)
}